import axios from "axios";
import { IBusPatternDto } from "./interfaces/IBusPatternDto";

export async function GetBusPatterns(routeId: string, serviceDate: string){
    const encodedRouteId = encodeURIComponent(routeId);
    const url = `/bus-patterns/list?routeId=${encodedRouteId}&serviceDate=${serviceDate}`;
    const response = await axios.get<IBusPatternDto[]>(url);
    return response.data;
}